import React from "react";

const TutorialForm = ({ name, grade, onClick, t_type }) => {
  const phase3 = [
    <div className="ai-txt-1">
      지금부터 AI스캐닝 진단 평가를 통해 <br />
      현재 {name} 학생의 수학 수준이 어느 정도인지 영역별로 분석할 거예요.
    </div>,
    <>
      <div className="ai-txt-1">
        초등 수학은 연산, 도형, 측정 등 영역별 개념을 확실히 깨치는 것이
        중요해요.
      </div>
      <div className="ai-txt-2">
        지금부터 AI스캐닝 진단 평가를 통해 <br />
        {name} 학생의 영역별 보완이 필요한 단원, 잘하고 있는 단원을 분석할
        거예요.
      </div>
    </>,
    <>
      <div className="ai-txt-1">
        대부분의 영역이 초등학교 5~6학년 때 배웠던 과정들이 이어지므로 <br />
        초등학교 수학 과정도 다시 한번 복습할 필요가 있답니다.
      </div>
      <div className="ai-txt-2">
        AI스캐닝 진단 평가를 통해 <br />
        {name} 학생의 보완이 필요한 학습, 잘하고 있는 학습을 분석할 거예요.
      </div>
    </>,
    <div className="ai-txt-1">
      AI스캐닝 진단 평가를 통해 <br />
      {name} 학생의 현재 보완이 필요한 단원, 잘하고 있는 단원을 분석하여 <br />
      적절한 학습을 추천해줄 거예요.
    </div>,
  ];
  const phase4 = [
    <div className="ai-txt-1">
      분석한 결과를 바탕으로 AI 추천학습을 꾸준히 공부한다면 <br />
      수학의 기본기를 탄탄하게 다지고 <br />
      어려운 응용 문제도 척척 해결할 수 있는 능력이 생길 거예요!
    </div>,
    <div className="ai-txt-1">
      분석한 결과를 바탕으로 AI 추천학습을 꾸준히 공부한다면 <br />
      수학의 개념을 탄탄하게 다지고 <br />
      어려운 응용 문제도 거뜬히 해결할 수 있는 능력이 생길 거예요!
    </div>,
    <div className="ai-txt-1">
      분석한 결과를 바탕으로 AI 추천학습을 지속적으로 공부한다면 <br />
      수학 5대 영역의 학습을 누수 없이 고르고 탄탄하게 <br />
      기본기를 다질 수 있을 거예요~!
    </div>,
  ];
  return (
    <>
      <div className="wrapper">
        <div className="math-AI-scanning">
          <div className="AI-tutorial">
            <div className="tutorial-element">
              {t_type === "reg-mem" && (
                <div className="top-close">
                  <button
                    className="btn-close"
                    onClick={() => {
                      window.handleConfirm();
                    }}
                  >
                    <i className="icon i-top-close">닫기</i>
                  </button>
                </div>
              )}
              <div className="ai-motion is-motion">
                <span className="i-motion i-motion-tutorial"></span>
              </div>
              <div className="ai-writer">
                <div className="dp-table">
                  <div className="dp-cell">
                    <div className="phase phase1 on">
                      <div className="ai-txt-1">어서오세요. {name} 학생.</div>
                      <div className="ai-txt-2">
                        {name} 학생이 영역별로 수학을 얼마나 잘 이해하고 있는지
                        분석하여 <br />
                        이미 잘하는 것은 더 잘할 수 있도록 강화하고 아직 부족한
                        것은 보완하여 잘할 수 있도록 <br />
                        학습을 추천하는 것이 이번 진단검사의 목적이예요.
                      </div>
                    </div>
                    <div className="phase phase2">
                      <div className="ai-txt-1">
                        {name} 학생은 현재{" "}
                        {parseInt(grade) < 7
                          ? `초등학교 ${parseInt(grade)}`
                          : `중학교 ${parseInt(grade) - 6}`}
                        학년이로군요?
                      </div>
                    </div>

                    <div className="phase phase3">
                      {parseInt(grade) < 3
                        ? phase3[0]
                        : parseInt(grade) < 7
                        ? phase3[1]
                        : parseInt(grade) === 7
                        ? phase3[2]
                        : phase3[3]}
                    </div>
                    <div className="phase phase4">
                      {parseInt(grade) < 3
                        ? phase4[0]
                        : parseInt(grade) < 7
                        ? phase4[1]
                        : phase4[2]}
                    </div>

                    <div className="phase phase5">
                      <div className="ai-txt-1">
                        그럼 이제 시작해볼까요? <br />
                        긴장하지 말고 차근차근 문제를 풀어 제출해 보세요.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ai-button">
                <button className="button-bottom button-next" onClick={onClick}>
                  NEXT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TutorialForm;
